/** @module form */

/**
 * Material-Design auf Formular-Elementen anwenden
 *
 * @property {NodeList} forms List with all forms
 * @property {Array}  materialElements All formElements with materialdesign
 */
export class OpaccFormMaterial {
	constructor() {
		//this.wrapperElement = document.querySelector('.content');
		this.forms = document.querySelectorAll('form');
		this.materialElements = this.getAllMaterialElements();
		if (this.materialElements) {
			this.attachEventListener();
		}
	}

	/**
	 * Event Registrierungen im DOM
	 *
	 */
	attachEventListener() {
		document.addEventListener('focus', (e) => {this.setFocusEventHandler(e);}, true);
		document.addEventListener('blur', (e) => {this.setBlurEventHandler(e);}, true);
	}

	/**
	 * Handler für den Event "onFocus"
	 *
	 * @param {Event} e Current event
	 */
	setFocusEventHandler(e) {
		let element = this.materialElements.find(item => {
			return item.formField == e.target;
		});
		if (element) {
			element.formFieldWrapper.classList.add('is-materialized');
		}
	}

	/**
	 * Handler für den Event "onBlur"
	 *
	 * @param {Event} e Current event
	 */
	setBlurEventHandler(e) {
		let element = this.materialElements.find(item => {
			return item.formField == e.target;
		});

		if (element) {
			if (element.formField.value.length > 0) {
				return;
			}

			element.formFieldWrapper.classList.remove('is-materialized');
		}
	}

	/**
	 *
	 * Identifiziere alle Material-Form-Elemente sämtlicher Formularen
	 *
	 * @returns {Array} Array mit allen Material-Form-Elementen
	 */
	getAllMaterialElements() {
		let materialElements = [];

		Array.from(this.forms).forEach(form => {
			let currentFormElements = Array.from(form.elements).map(item => {
				let formFieldWrapper = item.closest('.opc-form-field');
				if (formFieldWrapper && ('opLabel' in formFieldWrapper.dataset)) {
					return formFieldWrapper.dataset.opLabel === 'material' ? { 'formFieldWrapper': formFieldWrapper, 'formField': item } : '';
				}
			}).filter(item => {
				return typeof item === 'object';
			});
			materialElements.push(currentFormElements);
		});

		// flatten array to 1 dimension
		return [].concat(...materialElements);
	}
}